import React, { memo } from "react";
import CcPathwayNode from "./CcPathwayNode";
import { cx } from "../utils";

/**
 * CcPathwayPhasePanel — dashed phase container with header + pathway cards.
 * Used in stacked list and as the visual body of canvas phase columns.
 */
const CcPathwayPhasePanel = memo(
  ({
    phase,
    completedCount,
    totalCount,
    items = [],
    onTemplateClick,
    onDismissClick,
    onRestore,
    renderCardWrapper,
    className,
  }) => {
    const label = String(phase || "").toUpperCase();

    return (
      <div className={cx("cc-pathway-phase-panel", className)}>
        <div className="cc-pathway-phase-panel__header">
          <span className="cc-pathway-phase-panel__label">{label}</span>
          <span className="cc-pathway-phase-panel__meta">
            {completedCount} / {totalCount}
          </span>
        </div>
        <div className="cc-pathway-phase-panel__cards">
          {items.map((item, index) => {
            const card = (
              <CcPathwayNode
                item={item}
                variant="stacked"
                onTemplateClick={onTemplateClick}
                onDismissClick={onDismissClick}
                onRestore={onRestore}
              />
            );

            if (renderCardWrapper) {
              return renderCardWrapper(card, item, index);
            }

            return (
              <div
                key={`${item.template_id}-${item.template_name}-${index}`}
                className="cc-pathway-phase-panel__card-row"
              >
                {card}
              </div>
            );
          })}
        </div>
      </div>
    );
  },
);

CcPathwayPhasePanel.displayName = "CcPathwayPhasePanel";

export default CcPathwayPhasePanel;
